<div
  class="background-treino"
  [ngClass]="backgroundClass"
  [ngStyle]="{ animation: backgroundAnimation}">
</div>

<div class="main-timers">
  <router-outlet></router-outlet>
</div>
